import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import { FaInstagram, FaFacebookF, FaGithub } from 'react-icons/fa'
const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <span>vy9919855322@gmail.com</span>
        <div className="f-icons">
         <a href='https://www.instagram.com/the_vishalyadav7052/' ><FaInstagram color="white" size={"3rem"} /></a>
         <a href="https://www.facebook.com/profile.php?id=100039143774700&mibextid=ZbWKwL" ><FaFacebookF color="white" size={"3rem"} /></a>
         <a href="https://github.com/vishalyadav7565"><FaGithub  color="white" size={"3rem"} /></a>
        </div>
      </div>
    </div>
  );
};

export default Footer;